module.exports = __webpack_public_path__ + "static/img/5.a2b91ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/5.png
// module id = 1VRg
// module chunks = 0